import type { GroupedItem } from './types'

type Sector = { id: string; name: string }
type ItemWithSector = { id: string; name: string; sectorId: string }

/**
 * Groups items by sector and returns `GroupedItem[]` usable by `GenericSelectionModal`.
 */
export function groupItemsBySector(
  sectors: Sector[],
  items: ItemWithSector[],
): GroupedItem[] {
  if (!Array.isArray(sectors) || !sectors.length || !Array.isArray(items) || !items.length) return []

  return sectors
    .map((sector) => ({
      id: sector.id,
      name: sector.name,
      items: items
        .filter((item) => item.sectorId === sector.id)
        .map((item) => ({ id: item.id, name: item.name })),
    }))
    .filter((group) => group.items.length > 0)
}

